var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReserveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#123766"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0001 28C26.0376 28 28.5 25.5376 28.5 22.5C28.5 19.4624 26.0376 17 23.0001 17C19.9625 17 17.5001 19.4624 17.5001 22.5C17.5001 25.5376 19.9625 28 23.0001 28Z",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 20.3438V22.4997L24.5 23.9997",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 9V11",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9V11",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5306 27C13.9255 27 13.0178 27 11.8075 27C11.0051 27 10.7142 26.9218 10.4208 26.775C10.1275 26.6282 9.8973 26.4128 9.74042 26.1384C9.58354 25.8639 9.5 25.5917 9.5 24.8409V13.1591C9.5 12.4083 9.58354 12.1361 9.74042 11.8616C9.8973 11.5871 10.1275 11.3717 10.4208 11.225C10.7142 11.0782 11.0051 11 11.8075 11H25.8914C26.5 11 27.5 11.5 27.5 12.5C27.5 12.5 27.5 13.2467 27.5 13.9975",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReserveIcon);
export default __webpack_public_path__ + "static/media/reserveIcon.d565f3f2a29db6a7fc61f2b9ae3816ab.svg";
export { ForwardRef as ReactComponent };